import styled from 'styled-components';
import { mr, mt } from '@upgrade/react-components/Spacing/core';

// eslint-disable-next-line import/prefer-default-export
export const HeaderContainer = styled.div`
  ${props => {
    const { white, theme } = props;

    return !white
      ? `
        .header-nav-menu__link:hover {
          color: ${theme.palette.actionableHover};
        }
      `
      : undefined;
  }}

  position: ${({ fixedHeader }) => (fixedHeader ? 'absolute' : 'relative')};
  left: 0;
  right: 0;
  z-index: 2;
`;

export const FooterContainer = styled.div`
  .footer {
    ${mt('none')};
    background-color: ${({ whiteFooter, theme }) => whiteFooter && theme.palette.backgroundPrimary};
    color: ${({ whiteFooter, theme }) => whiteFooter && theme.palette.content};
  }
  .footer-social__item {
    color: ${({ whiteFooter, theme }) => whiteFooter && theme.palette.actionablePrimary};
  }

  .footer-menu__item {
    ${mr('sm')};
  }
`;

export const FooterLinkGroup = styled.li`
  width: 15rem;
  @media (max-width: ${props => props.theme.mediaSm}) {
    margin: 0 auto;
  }
`;

export const StyledLi = styled.li`
  .footer-menu__item__link {
    color: ${props => props.theme.palette.content} !important;
  }
`;

export const HeaderLogoContainer = styled.div`
  svg {
    width: 10rem;
    @media (min-width: ${props => props.theme.mediaMd}) {
      width: auto;
    }
  }
`;

export const MerchantLoginLink = styled.a`
  border: 2px solid ${props => props.theme.palette.border};
  border-radius: ${props => props.theme.smallBorderRadius};

  @media (max-width: ${props => props.theme.mediaXs}) {
    display: inline-block;
    margin: 1rem 0 0 -1rem;
  }
`;
